import Icon from '../components/Icon.vue'

Icon.register({
  blog: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M172.2 226.8c75.5 15 129.9 89.3 112.5 172.2-11.4 54.3-55.3 98.3-109.7 109.7-92.9 19.5-175-51.2-175-140.7v-248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v248c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.6-13.1-38.2-31.3-45-9.6-3.6-16.7-11.8-16.7-22v-50.4c0-14.9 13.6-26.7 28.2-23.8zM209 0c163.2 8.6 294.4 139.8 302.9 303 0.5 9.2-6.8 17-16 17h-32.1c-8.4 0-15.4-6.6-15.9-15-7.5-129.5-111.5-234.5-240.9-241.5-8.4-0.4-15-7.4-15-15.9v-31.6c0-9.2 7.8-16.5 17-16zM209.3 96c110.1 8.5 198.2 96.6 206.6 206.7 0.7 9.3-6.8 17.3-16.1 17.3h-32.2c-8.3 0-15.1-6.4-15.9-14.7-6.9-77-68.1-138.9-144.9-145.2-8.3-0.6-14.8-7.5-14.8-15.9v-32.1c0-9.4 8-16.8 17.3-16.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/blog.js
// module id = 671
// module chunks = 0